import IMask from "imask";
import { __ } from "@wordpress/i18n";

export default class VindiMultipayment {
    constructor(settings = {}) {
        this.settings = {
            ajaxUrl: settings.ajaxUrl || (typeof ajaxurl !== 'undefined' ? ajaxurl : '/wp-admin/admin-ajax.php'),
            nonce: settings.nonce || '',
            ...settings
        };

        if (!this.settings.nonce) {
            const nonceField = document.querySelector('input[name="vindi-pagamento_nonce"]');
            if (nonceField) {
                this.settings.nonce = nonceField.value;
            }
        }

        this.init();
    }

    init() {
        this.initElements();

        if (this.firstMethodSelect && this.secondMethodSelect) {
            this.setupEventListeners();
            this.initializePaymentFields();
        }

        this.prepareFormSubmission();
        this.initPaymentMethodListener('first');
        this.initPaymentMethodListener('second');
    }

    initElements() {
        this.firstMethodSelect = document.getElementById('first_payment_method');
        this.secondMethodSelect = document.getElementById('second_payment_method');
        this.firstAmountInput = document.getElementById('first_payment_amount');
        this.secondAmountInput = document.getElementById('second_payment_amount');
        this.cartTotalInput = document.getElementById('cart_total');
        this.errorDiv = document.getElementById('first-payment-amount-error');
    }

    setupEventListeners() {
        this.firstMethodSelect.addEventListener('change', () => {
            this.firstMethodValue = this.firstMethodSelect.value;
            this.updateSecondMethodOptions(this.firstMethodSelect.value);
            this.updatePaymentMethodFields(this.firstMethodSelect.value, 'first');
        });

        this.secondMethodSelect.addEventListener('change', () => {
            this.secondMethodValue = this.secondMethodSelect.value;
            this.updateFirstMethodOptions(this.secondMethodSelect.value);
            this.updatePaymentMethodFields(this.secondMethodSelect.value, 'second');
        });

        if (this.firstAmountInput && this.secondAmountInput && this.cartTotalInput) {
            this.firstAmountInput.addEventListener('input', () => {
                this.updateSecondAmount();
            });
        }

        document.addEventListener('updated_checkout', () => {
            setTimeout(() => {
                const firstMethod = this.firstMethodSelect?.value;
                const secondMethod = this.secondMethodSelect?.value;

                if (firstMethod === 'credit_card') {
                    this.setupCreditCardFunctionality('first');
                }

                if (secondMethod === 'credit_card') {
                    this.setupCreditCardFunctionality('second');
                }
            }, 500);
        });

        document.addEventListener('input', (e) => {
            if (e.target && e.target.id === 'first_wvp-card-number') {
                try {
                    this.handleCardBrandDetection(e.target, 'first');
                } catch (error) {
                    console.warn('Erro ao detectar bandeira do primeiro cartão:', error);
                }
            }

            if (e.target && e.target.id === 'second_wvp-card-number') {
                try {
                    this.handleCardBrandDetection(e.target, 'second');
                } catch (error) {
                    console.warn('Erro ao detectar bandeira do segundo cartão:', error);
                }
            }
        });
    }

    updateSecondMethodOptions(firstMethod) {
        jQuery.ajax({
            url: wc_checkout_params.wc_ajax_url
                .toString()
                .replace("%%endpoint%%", "vindi_get_compatible_methods"),
            type: 'POST',
            data: {
                selected_method: firstMethod,
                target_field: 'second',
                security: this.settings.nonce
            },
            success: (response) => {
                if (response.success && response.data) {
                    this.secondMethodSelect.innerHTML = '';

                    Object.keys(response.data).forEach(method => {
                        const option = document.createElement('option');
                        option.value = method;
                        option.textContent = response.data[method];
                        this.secondMethodSelect.appendChild(option);
                    });

                    if (this.secondMethodSelect.options.length > 0) {
                        const optionStillExists = Array.from(this.secondMethodSelect.options).some(
                            option => option.value === this.secondMethodValue
                        );

                        if (optionStillExists) {
                            this.secondMethodSelect.value = this.secondMethodValue
                        } else if (this.secondMethodSelect.options.length > 0) {
                            this.secondMethodSelect.selectedIndex = 0;
                        }
                        this.updatePaymentMethodFields(this.secondMethodSelect.value, 'second');
                    }

                }
            }
        });
    }

    updateFirstMethodOptions(secondMethod) {
        jQuery.ajax({
            url: wc_checkout_params.wc_ajax_url
                .toString()
                .replace("%%endpoint%%", "vindi_get_compatible_methods"),
            type: 'POST',
            data: {
                selected_method: secondMethod,
                target_field: 'first',
                security: this.settings.nonce
            },
            success: (response) => {
                if (response.success && response.data) {
                    this.firstMethodSelect.innerHTML = '';

                    Object.keys(response.data).forEach(method => {
                        const option = document.createElement('option');
                        option.value = method;
                        option.textContent = response.data[method];
                        this.firstMethodSelect.appendChild(option);
                    });

                    if (this.firstMethodSelect.options.length > 0) {
                        const optionStillExists = Array.from(this.firstMethodSelect.options).some(
                            option => option.value === this.firstMethodValue
                        );
                        if (optionStillExists) {
                            this.firstMethodSelect.value = this.firstMethodValue
                        } else if (this.firstMethodSelect.options.length > 0) {
                            this.secondMethodSelect.selectedIndex = 0;
                        }
                        this.updatePaymentMethodFields(this.firstMethodSelect.value, 'first');
                    }
                }
            }
        });
    }

    initializePaymentFields() {
        if (this.firstMethodSelect && this.firstMethodSelect.value) {
            this.updatePaymentMethodFields(this.firstMethodSelect.value, 'first');
            this.updateSecondMethodOptions(this.firstMethodSelect.value);
        }

        if (this.secondMethodSelect && this.secondMethodSelect.value) {
            this.updatePaymentMethodFields(this.secondMethodSelect.value, 'second');
        } else if (this.secondMethodSelect) {
            const options = this.secondMethodSelect.options;
            if (options.length > 0) {
                this.secondMethodSelect.value = options[0].value;
                this.updatePaymentMethodFields(options[0].value, 'second');
            }
        }

        this.updateSecondAmount();
    }

    updatePaymentMethodFields(methodType, prefix) {
        if (!methodType) {
            return;
        }

        const containerPrefix = prefix === 'first' ? 'payment-method-' : 'second-payment-method-';
        const methodContainers = document.querySelectorAll(`.${prefix}-payment-method .payment-method-content`);

        methodContainers.forEach(el => {
            el.style.display = 'none';
        });

        const selectedContainer = document.getElementById(`${containerPrefix}${methodType}`);

        if (selectedContainer) {
            selectedContainer.style.display = 'block';
        } else {
            this.loadPaymentMethodFields(methodType, prefix);
        }

        if (methodType === 'credit_card') {
            this.setupCreditCardFunctionality(prefix);
        }
    }

    setupCreditCardFunctionality(prefix) {
        if (prefix === 'first') {
            this.setCardNumberMask(prefix);
            this.setCardOwnerMask(prefix);
            this.setCardCodeMask(prefix);
            this.setCardDateMask(prefix);
            this.manageTokenSelect(prefix);

            const cardNumberInput = document.getElementById('first_wvp-card-number');
            if (cardNumberInput && cardNumberInput.value) {
                this.detectCardBrand(cardNumberInput, 'first');
            }
        } else {
            this.setCardNumberMask(prefix);
            this.setCardOwnerMask(prefix);
            this.setCardDateMask(prefix);
            this.setCardCodeMask(prefix);
            this.manageTokenSelect(prefix);

            const cardNumberInput = document.getElementById('second_wvp-card-number');
            if (cardNumberInput && cardNumberInput.value) {
                this.detectCardBrand(cardNumberInput, 'second');
            }
        }
    }

    loadPaymentMethodFields(method, prefix) {
        const amountInput = prefix === 'first' ? this.firstAmountInput : this.secondAmountInput;
        const amount = amountInput ? amountInput.value : '0,00';
        const container = document.getElementById(`${prefix}-payment-method-fields`);

        if (!container) {
            return;
        }

        container.innerHTML = '<div class="loading">Carregando...</div>';

        jQuery.ajax({
            url: wc_checkout_params.wc_ajax_url
                .toString()
                .replace("%%endpoint%%", "vindi_load_payment_method_fields"),
            type: 'POST',
            data: {
                method: method,
                prefix: prefix + '_',
                amount: this.parseMoneyValue(amount).toString(),
                security: this.settings.nonce
            },
            success: (response) => {
                if (response.success && response.data) {
                    const fieldId = prefix === 'first' ? 'payment-method-' + method : 'second-payment-method-' + method;

                    const existingDiv = document.getElementById(fieldId);
                    if (existingDiv) {
                        existingDiv.remove();
                    }

                    const fieldDiv = document.createElement('div');
                    fieldDiv.id = fieldId;
                    fieldDiv.className = 'payment-method-content ' + prefix + '-payment-' + method;
                    fieldDiv.innerHTML = response.data;
                    container.innerHTML = '';
                    container.appendChild(fieldDiv);
                    fieldDiv.style.display = 'block';

                    if (method === 'credit_card') {
                        this.initCreditCardMasks(prefix);
                        this.setupCreditCardFunctionality(prefix);
                        this.initPaymentMethodListener(prefix);
                    }
                } else {
                    container.innerHTML = '<p>Não foi possível carregar os campos para ' + method + '.</p>';
                }
            },
            error: (xhr, status, error) => {
                console.error(`Erro ao carregar campos para ${method}:`, error);
                container.innerHTML = '<p>Erro ao carregar campos do método de pagamento.</p>';
            }
        });
    }

    updateSecondAmount() {
        if (!this.firstAmountInput || !this.secondAmountInput || !this.cartTotalInput) return;

        let firstValue = this.parseMoneyValue(this.firstAmountInput.value);
        const cartTotal = parseFloat(this.cartTotalInput.value) || 0;

        if (firstValue <= 0 || firstValue >= cartTotal) {
            if (this.errorDiv) this.errorDiv.style.display = 'block';
            this.firstAmountInput.classList.add('error');
        } else {
            if (this.errorDiv) this.errorDiv.style.display = 'none';
            this.firstAmountInput.classList.remove('error');
        }

        const secondValue = Math.max(0, cartTotal - firstValue);
        this.secondAmountInput.value = this.formatMoneyDisplay(secondValue);

        const secondOriginalInput = document.getElementById('second_payment_amount_original');
        if (secondOriginalInput) {
            secondOriginalInput.value = secondValue.toFixed(2);
        }

        const firstAmountForInstallments = document.getElementById('vindi_first_amount_for_installments');
        const secondAmountForInstallments = document.getElementById('vindi_second_amount_for_installments');

        if (firstAmountForInstallments) {
            firstAmountForInstallments.value = firstValue.toFixed(2);
        }

        if (secondAmountForInstallments) {
            secondAmountForInstallments.value = secondValue.toFixed(2);
        }
        setTimeout(() => {
            const firstMethod = this.firstMethodSelect.value;
            const secondMethod = this.secondMethodSelect.value;

            if (firstMethod === 'credit_card') {
                try {
                    this.getCardInstallments();
                } catch (e) {
                    console.warn('Erro ao atualizar parcelas do primeiro método:', e);
                }
            }

            if (secondMethod === 'credit_card') {
                try {
                    this.getSecondMethodInstallments();
                } catch (e) {
                    console.warn('Erro ao atualizar parcelas do segundo método:', e);
                }
            }
        }, 300);
    }

    formatMoneyDisplay(value) {
        return value.toFixed(2).replace('.', ',');
    }

    parseMoneyValue(value) {
        if (!value) return 0;
        return parseFloat(value.toString().replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;
    }

    initCreditCardMasks(prefix = '') {
        const prefixStr = prefix ? prefix + '_' : '';

        const cardNumberInput = document.getElementById(prefixStr + 'wvp-card-number');
        if (cardNumberInput) {
            cardNumberInput.addEventListener('input', function () {
                let value = this.value.replace(/\D/g, '');
                let formattedValue = '';

                for (let i = 0; i < value.length; i++) {
                    if (i > 0 && i % 4 === 0) {
                        formattedValue += ' ';
                    }
                    formattedValue += value[i];
                }

                this.value = formattedValue.substring(0, 19);
            });
        }

        const cardDateInput = document.getElementById(prefixStr + 'wvp-card-date');
        if (cardDateInput) {
            cardDateInput.addEventListener('input', function () {
                let value = this.value.replace(/\D/g, '');
                let formattedValue = '';

                if (value.length > 2) {
                    formattedValue = value.substring(0, 2) + '/' + value.substring(2, 4);
                } else {
                    formattedValue = value;
                }

                this.value = formattedValue.substring(0, 5);
            });
        }

        const cardCodeInput = document.getElementById(prefixStr + 'wvp-card-code');
        if (cardCodeInput) {
            cardCodeInput.addEventListener('input', function () {
                let value = this.value.replace(/\D/g, '');
                this.value = value.substring(0, 4);
            });
        }
    }

    prepareFormSubmission() {
        const checkoutForm = document.querySelector('form.checkout');
        if (!checkoutForm) return;
        const methodMap = {
            'credit_card': 'vindi-pagamentos-credit',
            'pix': 'vindi-pagamentos-pix',
            'bolepix': 'vindi-pagamentos-bolepix'
        };

        checkoutForm.addEventListener('submit', (e) => {
            const selectedPaymentMethod = document.querySelector('input[name="payment_method"]:checked');
            if (!selectedPaymentMethod || selectedPaymentMethod.value !== 'vindi-pagamentos-multi-payment') return;
            this.initElements();

            const firstMethodShort = this.firstMethodSelect ? this.firstMethodSelect.value : '';
            const secondMethodShort = this.secondMethodSelect ? this.secondMethodSelect.value : '';

            if (firstMethodShort === 'credit_card' && secondMethodShort === 'credit_card') {
                const firstCardNumber = document.getElementById('first_wvp-card-number');
                const secondCardNumber = document.getElementById('second_wvp-card-number');

                if (firstCardNumber && secondCardNumber) {
                    const firstCardClean = firstCardNumber.value.replace(/\s/g, '');
                    const secondCardClean = secondCardNumber.value.replace(/\s/g, '');

                    if (firstCardClean === secondCardClean && firstCardClean !== '') {
                        e.preventDefault();
                        alert(__('Você não pode usar o mesmo cartão para ambos os métodos de pagamento.', 'vindi'));
                        return false;
                    }
                }
            }

            this.removeExistingInputs(checkoutForm, 'multi_payment');

            const firstMethod = methodMap[firstMethodShort] || firstMethodShort;
            const secondMethod = methodMap[secondMethodShort] || secondMethodShort;


            const firstAmount = this.firstAmountInput ? this.firstAmountInput.value : '';
            const secondAmount = this.secondAmountInput ? this.secondAmountInput.value : '';
            this.addHiddenInput(checkoutForm, 'multi_payment[first_method]', firstMethod);
            this.addHiddenInput(checkoutForm, 'multi_payment[second_method]', secondMethod);
            this.addHiddenInput(checkoutForm, 'multi_payment[first_amount]', firstAmount);
            this.addHiddenInput(checkoutForm, 'multi_payment[second_amount]', secondAmount);

            const firstPaymentMethodId = this.getPaymentMethodId(firstMethodShort);
            this.addHiddenInput(checkoutForm, 'payment[payment_method_id]', firstPaymentMethodId);

            if (firstMethodShort === 'credit_card') {
                this.collectFirstCreditCardData(checkoutForm);
            }

            if (secondMethodShort === 'credit_card') {
                this.collectSecondCreditCardData(checkoutForm);
            }
        });
    }

    collectFirstCreditCardData(form) {
        const cardOwner = document.getElementById('first_wvp-card-owner');
        const cardNumber = document.getElementById('first_wvp-card-number');
        const cardDate = document.getElementById('first_wvp-card-date');
        const cardCode = document.getElementById('first_wvp-card-code');
        const installments = document.getElementById('first_wvp-card-installments');
        const brandInput = document.getElementById('first_wvp-card-brand');

        if (cardNumber) {
            this.addHiddenInput(form, 'payment[card_number]', cardNumber.value.replace(/\s/g, ''));
        }

        if (cardOwner) {
            this.addHiddenInput(form, 'payment[card_name]', cardOwner.value);
        }

        if (cardCode) {
            this.addHiddenInput(form, 'payment[card_cvv]', cardCode.value);
        }

        if (installments) {
            this.addHiddenInput(form, 'payment[split]', installments.value);
        }

        if (brandInput) {
            this.addHiddenInput(form, 'payment[payment_method_id]', brandInput.value || '1');
        }

        if (cardDate) {
            const dateParts = cardDate.value.split('/');
            if (dateParts.length === 2) {
                const month = dateParts[0];
                const year = '20' + dateParts[1];

                this.addHiddenInput(form, 'payment[card_expiration_date]', cardDate.value);
                this.addHiddenInput(form, 'payment[card_expdate_month]', month);
                this.addHiddenInput(form, 'payment[card_expdate_year]', year);
            }
        }
    }

    collectSecondCreditCardData(form) {
        const cardOwner = document.getElementById('second_wvp-card-owner');
        const cardNumber = document.getElementById('second_wvp-card-number');
        const cardDate = document.getElementById('second_wvp-card-date');
        const cardCode = document.getElementById('second_wvp-card-code');
        const installments = document.getElementById('second_wvp-card-installments');
        const brandInput = document.getElementById('second_wvp-card-brand');

        if (cardNumber) {
            this.addHiddenInput(form, 'second_payment[card_number]', cardNumber.value.replace(/\s/g, ''));
        }

        if (cardOwner) {
            this.addHiddenInput(form, 'second_payment[card_name]', cardOwner.value);
        }

        if (cardCode) {
            this.addHiddenInput(form, 'second_payment[card_cvv]', cardCode.value);
        }

        if (installments) {
            this.addHiddenInput(form, 'second_payment[split]', installments.value);
        }

        if (brandInput) {
            this.addHiddenInput(form, 'second_payment[payment_method_id]', brandInput.value || '1');
        }

        if (cardDate) {
            const dateParts = cardDate.value.split('/');
            if (dateParts.length === 2) {
                const month = dateParts[0];
                const year = '20' + dateParts[1];

                this.addHiddenInput(form, 'second_payment[card_expiration_date]', cardDate.value);
                this.addHiddenInput(form, 'second_payment[card_expdate_month]', month);
                this.addHiddenInput(form, 'second_payment[card_expdate_year]', year);
            }
        }
    }

    removeExistingInputs(form, prefix) {
        const existingInputs = form.querySelectorAll(`input[name^="${prefix}["]`);
        existingInputs.forEach(input => input.remove());
    }

    getPaymentMethodId(method) {
        const idMap = {
            'pix': '27',           // ID numérico para Pix
            'credit_card': '1',    // ID numérico para Cartão de Crédito
            'bolepix': '28'        // ID numérico para Bolepix
        };

        return idMap[method] || '';
    }

    addHiddenInput(form, name, value) {
        const existingInput = form.querySelector(`input[name="${name}"]`);
        if (existingInput) {
            existingInput.value = value;
            return;
        }

        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    setCardBrand(name, code, prefix) {
        const prefixId = prefix === 'first' ? 'first_' : 'second_';
        const brandIcon = document.getElementById(`${prefixId}wvp-brand-icon`);
        const brandInput = document.getElementById(`${prefixId}wvp-card-brand`);

        if (brandIcon) {
            const currentImg = brandIcon.getAttribute('data-img');

            if (currentImg) {
                const newImgSrc = brandIcon.src.replace(currentImg, name);
                brandIcon.src = newImgSrc;
                brandIcon.setAttribute('data-img', name);
            }
        }

        if (brandInput) {
            brandInput.value = code;
        }

        const brandChangeEvent = new CustomEvent('vindi_card_brand_changed', {
            detail: { prefix, name, code }
        });
        document.dispatchEvent(brandChangeEvent);

        if (name !== 'mono/generic') {
            this.updateInstallmentsForBrand(prefix, code);
        }
    }

    updateInstallmentsForBrand(prefix, brandCode) {
        if (prefix === 'first') {
            try {
                this.getCardInstallments(null, null, this.parseMoneyValue(this.firstAmountInput.value));
                return;
            } catch (e) {
                console.warn('Erro ao chamar getCardInstallments:', e);
            }
        }

        if (prefix === 'second') {
            try {
                this.getSecondMethodInstallments(null, null, this.parseMoneyValue(this.secondAmountInput.value));
                return;
            } catch (e) {
                console.warn('Erro ao chamar getSecondMethodInstallments:', e);
            }
        }
    }


    updateCompatibleMethods(selectedMethod, targetField) {
        const targetSelect = targetField === 'first' ? this.firstMethodSelect : this.secondMethodSelect;
        if (!targetSelect) return;

        const currentSelection = targetSelect.value;
        jQuery.ajax({
            url: wc_checkout_params.wc_ajax_url
                .toString()
                .replace("%%endpoint%%", "vindi_get_compatible_methods"),
            type: 'POST',
            data: {
                selected_method: selectedMethod,
                target_field: targetField,
                security: this.settings.nonce
            },
            success: (response) => {
                if (response.success && response.data) {
                    targetSelect.innerHTML = '';

                    Object.keys(response.data).forEach(method => {
                        const option = document.createElement('option');
                        option.value = method;
                        option.textContent = response.data[method];
                        targetSelect.appendChild(option);
                    });

                    const optionExists = Array.from(targetSelect.options)
                        .some(opt => opt.value === currentSelection);

                    if (optionExists) {
                        targetSelect.value = currentSelection;
                    } else if (targetSelect.options.length > 0) {
                        targetSelect.value = targetSelect.options[0].value;
                        targetSelect.dispatchEvent(new Event('change'));
                    }
                }
            },
            error: (xhr, status, error) => {
                console.error('Erro ao obter métodos compatíveis:', error);
            }
        });
    }

    setCardNumberMask(prefix) {
        const prefixId = prefix === 'first' ? 'first_' : 'second_';
        const field = document.querySelector(`#${prefixId}wvp-card-number`);

        if (field) {
            if (!field.classList.contains("wvp-block-field")) {
                IMask(field, {
                    mask: "0000 0000 0000 0000",
                });
            }

            this.detectCardBrand(field, prefix);

            field.addEventListener("input", () => {
                this.detectCardBrand(field, prefix);
            });
        }
    }

    setCardOwnerMask(prefix) {
        const prefixId = prefix === 'first' ? 'first_' : 'second_';
        const field = document.querySelector(`#${prefixId}wvp-card-owner`);

        if (field && !field.classList.contains("wvp-block-field")) {
            const mask = IMask(field, {
                mask: /^[A-Za-z\s]*$/,
            });

            field.addEventListener("input", () => {
                field.value = field.value.toUpperCase();
                mask.updateValue();
            });
        }
    }

    setCardDateMask(prefix) {
        const prefixId = prefix === 'first' ? 'first_' : 'second_';
        const field = document.querySelector(`#${prefixId}wvp-card-date`);

        if (field && !field.classList.contains("wvp-block-field")) {
            IMask(field, {
                mask: "00/00",
            });
        }
    }

    setCardCodeMask(prefix) {
        const prefixId = prefix === 'first' ? 'first_' : 'second_';
        const field = document.querySelector(`#${prefixId}wvp-card-code`);

        if (field) {
            if (!field.classList.contains("wvp-block-field")) {
                IMask(field, {
                    mask: "0000",
                });
            }

            field.addEventListener("input", () => {
                this.setCodeBrand(field, prefix);
            });
        }
    }

    detectCardBrand(cardInput, prefix) {
        const cardNumber = cardInput.value.replace(/\s/g, "");

        if (cardNumber.length < 6) {
            return;
        }

        const brands = this.getBrands();
        let foundBrand = null;

        brands.forEach(brand => {
            if (brand.regex.test(cardNumber) && !foundBrand) {
                foundBrand = brand;
            }
        });

        if (foundBrand) {
            this.setCardBrand(foundBrand.name, foundBrand.code, prefix);
            this.resetInstallmentsError(prefix === 'second');
            if (cardNumber.length >= 13) {
                if (prefix === 'first') {
                    this.getCardInstallments();
                } else {
                    this.getSecondMethodInstallments();
                }
            }
            return true;
        } else {
            this.setCardBrand("mono/generic", 1, prefix);
            this.showInstallmentsError(prefix === 'second');
            return false;
        }
    }

    showInstallmentsError(isSecondMethod = false) {
        const errorList = isSecondMethod ?
            document.querySelector("#second_wvp-installments-error") :
            document.querySelector("#first_wvp-installments-error");

        if (errorList) {
            errorList.innerText = __(
                "Não foi possível acessar os dados de parcelamento para esta bandeira de cartão.",
                "vindi-pagamentos",
            );
            errorList.classList.add("active");
        }
    }

    resetInstallmentsError(isSecondMethod = false) {
        const errorList = isSecondMethod ?
            document.querySelector("#second_wvp-installments-error") :
            document.querySelector("#first_wvp-installments-error");

        if (errorList) {
            errorList.innerText = "";
            errorList.classList.remove("active");
        }
    }

    getBrands() {
        return [
            {
                code: 16,
                name: "elo",
                regex: /^(401178|401179|431274|438935|451416|457393|457631|457632|504175|506699|5067[0-6][0-9]|506777|506778|509[0-8][0-9]{2}|50999[0-8][0-9]|509999[0-9]|627780|636297|636368|636369|650003[1-3]|650003[5-9]|650004[0-9]|650005[0-1]|650405|650406|650407|650408|650409|650410[5-9]|650411[0-9]|650412[0-9]|650485|650486|650487|650488|650489|650490[0-9]|650491[0-8]|6505[0-8][0-9]|6507[0-6][0-9]|6507[7-8][0-9]|6509[0-8][0-9]{2}|650999[0-8][0-9]|6509999|65165[2-9]|65166[0-9]|655000|655[1-6][0-9]{2}|6557[0-9]{3}|6558[0-9]{3}|6559[0-8][0-9]{2}|655999|655(99[7-9]|9[8-9][0-9])|6504[0-5][0-9]{2}|65047[1-9]|6504[8-9][0-9]|650[5-6][0-9]{3}|6507[0-5][0-9]{2}|6507[8-9][0-9]{2}|650(8[0-4][0-9]{2}|850|86[0-9]{2}|870|88[0-9]{2})|65[1-5][0-9]{4}|65[6-9][0-9]{4}|6516[5-6][0-9]{2}|65167[0-9]|6517[0-8][0-9]{2}|65179[0-8][0-9]{2}|651799)/,
            },
            {
                code: 3,
                name: "visa",
                regex: /^4[0-9]{12}(?:[0-9]{3})?$/,
            },
            {
                code: 4,
                name: "mastercard",
                regex: /^5[1-5][0-9]{14}$|^2[2-7][0-9]{14}$/,
            },
            {
                code: 5,
                name: "amex",
                regex: /^3[47][0-9]{13}$/,
            },
            {
                code: 25,
                name: "hipercard",
                regex: /^(606282|3841\d{2}|60(?!11)\d{2})\d{10}$/,
            },
            {
                code: 20,
                name: "hiper",
                regex: /^(637095|637599|637612|637609|637598)\d*$/,
            },
        ];
    }

    setCodeBrand(code, prefix) {
        const prefixId = prefix === 'first' ? 'first_' : 'second_';
        const img = document.querySelector(`#${prefixId}wvp-cvv-icon`);
        const brand = code.length < 3 ? "mono/cvv" : "cvv";

        if (img) {
            const attr = img.getAttribute("data-img");
            if (attr) {
                img.src = img.src.replace(attr, brand);
                img.setAttribute("data-img", brand);
            }
        }
    }

    manageTokenSelect(prefix) {
        const tokenSelector = prefix === 'first' ?
            'input[name="first_wc-vindi-pagamentos-credit-payment-token"]' :
            'input[name="second_wc-vindi-pagamentos-credit-payment-token"]';

        jQuery(tokenSelector).on('change', (e) => {
            if (jQuery(e.target).is(':checked')) {
                if (e.target.value !== 'new') {
                    if (prefix === 'first') {
                        this.getCardInstallments(e.target.value);
                    } else {
                        this.getSecondMethodInstallments(e.target.value);
                    }
                } else {
                    const installmentsSelector = prefix === 'first' ?
                        "#first_wvp-card-installments" :
                        "#second_wvp-card-installments";

                    const select = document.querySelector(installmentsSelector);
                    if (select) {
                        const selectedValue = select.value;
                        select.innerHTML = "";

                        if (prefix === 'first') {
                            this.getCardInstallments(null, selectedValue);
                        } else {
                            this.getSecondMethodInstallments(null, selectedValue);
                        }
                    }
                }
            }
        });
    }

    getCardInstallments(token = null, savedSelection = null, price = null) {
        const installmentsSelector = "#first_wvp-card-installments";
        const brandSelector = "#first_wvp-card-brand";
        const nonceSelector = "#first_wvp-card-nonce";
        const errorSelector = "#first_wvp-installments-error";
        const fieldsSelector = ".wvp-credit-fields:not(#segundo-metodo-pagamento .wvp-credit-fields)";

        if (!document.querySelector(installmentsSelector)) {
            return;
        }

        const brand = document.querySelector(brandSelector);
        const nonce = document.querySelector(nonceSelector);
        const total = document.querySelector("#wvp-cart-total");

        if (!brand) {
            return;
        }

        this.resetInstallmentsError(false);

        jQuery('form.checkout').block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });

        this.setRequestLoader(false);

        const isMultiPaymentActive = jQuery('#multi_payment_toggle').is(':checked') ||
            jQuery('#vindi_multi_payment_active').val() === '1';

        const data = {
            _wpnonce: nonce.value,
            security: wc_checkout_params.update_order_review_nonce,
        };

        if (isMultiPaymentActive) {
            const firstAmount = jQuery('#first_payment_amount').val();
            if (firstAmount) {
                data.price = firstAmount.replace(',', '.');
            } else {
                data.price = total.value;
            }
        } else {
            data.price = total.value;
        }

        data.brand = brand.value;

        if (token) {
            data.token = token;
        }

        const currentToken = token;

        const xhr = jQuery.ajax({
            url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'checkout_installments'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: (response) => {
                const select = document.querySelector(installmentsSelector);
                select.innerHTML = "";
                if (response.success) {
                    const installments = response.data.installments;
                    const errorList = document.querySelector(errorSelector);

                    if (response.data.message && errorList) {
                        errorList.textContent = response.data.message;
                        errorList.classList.add("active");
                    }

                    if (select) {
                        if (!savedSelection && select.value) {
                            savedSelection = select.value;
                        }

                        const existingOptions = {};

                        select.innerHTML = "";

                        for (const key in installments) {
                            const option = document.createElement("option");
                            option.value = key;
                            option.innerText = installments[key];

                            if (!existingOptions[key]) {
                                existingOptions[key] = true;
                                select.appendChild(option);
                            }
                        }

                        if (savedSelection && select.querySelector(`option[value="${savedSelection}"]`)) {
                            select.value = savedSelection;
                        }
                    }
                }
            },
            error: (xhr, status, error) => {
                if (status !== 'abort') {
                    const errorList = document.querySelector(errorSelector);
                    if (errorList && errorList.innerHTML === "") {
                        const span = document.createElement("span");
                        span.innerText = error.message;
                        errorList.appendChild(span);
                        errorList.classList.add("active");
                    }
                }
            },
            complete: () => {
                jQuery(fieldsSelector).removeClass("processing").unblock();
                jQuery('form.checkout').unblock();
            }
        });

        const tokenSelector = 'input[name="wc-vindi-pagamentos-credit-payment-token"]';

        jQuery(tokenSelector).on('change', (e) => {
            if (jQuery(e.target).is(':checked') && e.target.value !== currentToken) {
                xhr.abort();
            }
        });
    }

    setRequestLoader(isSecondMethod = false) {
        const fieldsSelector = isSecondMethod ?
            "#segundo-metodo-pagamento .wvp-credit-fields" :
            ".wvp-credit-fields:not(#segundo-metodo-pagamento .wvp-credit-fields)";

        jQuery(fieldsSelector).addClass("processing").block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });
    }

    getSecondMethodInstallments(token = null, savedSelection = null, price = null) {
        const installmentsSelector = "#second_wvp-card-installments";
        const brandSelector = "#second_wvp-card-brand";
        const nonceSelector = "#second_wvp-card-nonce";
        const errorSelector = "#second_wvp-installments-error";
        const fieldsSelector = "#segundo-metodo-pagamento .wvp-credit-fields";

        if (!document.querySelector(installmentsSelector)) {
            return;
        }

        const brand = document.querySelector(brandSelector);
        const nonce = document.querySelector(nonceSelector);

        if (!brand) {
            return;
        }

        const errorList = document.querySelector(errorSelector);
        if (errorList) {
            errorList.innerText = "";
            errorList.classList.remove("active");
        }

        jQuery('form.checkout').block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });

        jQuery(fieldsSelector).addClass("processing").block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });

        let secondValue = 0;

        if (price) {
            secondValue = parseFloat(price.toString().replace(',', '.'));
        } else {
            const secondAmountField = document.querySelector('#second_payment_amount');
            if (secondAmountField && secondAmountField.value) {
                secondValue = parseFloat(secondAmountField.value.replace(',', '.'));
            } else {
                jQuery(fieldsSelector).removeClass("processing").unblock();
                jQuery('form.checkout').unblock();
                return;
            }
        }

        const data = {
            _wpnonce: nonce.value,
            security: wc_checkout_params.update_order_review_nonce,
            price: secondValue.toString(),
            brand: brand.value,
            is_second_method: true
        };

        if (token) {
            data.token = token;
        }

        jQuery.ajax({
            url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'checkout_installments'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: (response) => {
                const select = document.querySelector(installmentsSelector);
                select.innerHTML = "";
                if (response.success) {
                    const originalInstallments = response.data.installments;
                    const correctedInstallments = {};

                    const firstOption = Object.values(originalInstallments)[0] || '';
                    const match = firstOption.match(/R\$\s?([0-9.,]+)/);

                    if (match && match[1]) {
                        const serverValue = parseFloat(match[1].replace('.', '').replace(',', '.'));

                        if (Math.abs(serverValue - secondValue) > 0.01) {
                            const ratio = secondValue / serverValue;

                            Object.keys(originalInstallments).forEach(key => {
                                const text = originalInstallments[key];
                                const valueParts = text.split('R$');

                                if (valueParts.length >= 2) {
                                    const valueStr = valueParts[1].trim().split(/\s|-|\(|>/)[0];
                                    const value = parseFloat(valueStr.replace('.', '').replace(',', '.'));

                                    const correctedValue = (value * ratio).toFixed(2).replace('.', ',');

                                    correctedInstallments[key] = text.replace(valueStr, correctedValue);

                                    if (text.includes('(R$')) {
                                        const totalMatch = text.match(/\(R\$\s?([0-9.,]+)/);
                                        if (totalMatch && totalMatch[1]) {
                                            const totalValue = parseFloat(totalMatch[1].replace('.', '').replace(',', '.'));
                                            const correctedTotal = (totalValue * ratio).toFixed(2).replace('.', ',');
                                            correctedInstallments[key] = correctedInstallments[key].replace(totalMatch[1], correctedTotal);
                                        }
                                    }
                                } else {
                                    correctedInstallments[key] = text;
                                }
                            });
                        } else {
                            Object.assign(correctedInstallments, originalInstallments);
                        }
                    } else {
                        Object.assign(correctedInstallments, originalInstallments);
                    }

                    if (select) {
                        if (!savedSelection && select.value) {
                            savedSelection = select.value;
                        }

                        Object.keys(correctedInstallments).forEach(key => {
                            const option = document.createElement("option");
                            option.value = key;
                            option.innerText = correctedInstallments[key];
                            select.appendChild(option);
                        });

                        if (savedSelection && select.querySelector(`option[value="${savedSelection}"]`)) {
                            select.value = savedSelection;
                        }
                    }
                }
            },
            error: (xhr, status, error) => {
                if (errorList) {
                    errorList.innerText = "Erro ao calcular parcelas: " + error;
                    errorList.classList.add("active");
                }
            },
            complete: () => {
                jQuery(fieldsSelector).removeClass("processing").unblock();
                jQuery('form.checkout').unblock();
            }
        });
    }

    initPaymentMethodListener(prefix) {
        const inputName = `${prefix}_wc-vindi-pagamentos-credit-payment-token`;
        const paymentOptions = document.querySelectorAll(`input[name="${inputName}"]`);
        const ownerFields = document.querySelector(`.${prefix}_wvp-credit-fields-hide`);
        const ownerCardDate = document.querySelector(`.${prefix}_wvp-card-date-hide`);

        paymentOptions.forEach((option) => {
            option.addEventListener('change', () => {
                const selectedOption = this.getSelectedPaymentMethod(prefix);
                if (selectedOption && selectedOption !== "new") {
                    if (ownerFields) ownerFields.style.display = 'none';
                    if (ownerCardDate) ownerCardDate.style.display = "none";
                } else {
                    if (ownerFields) ownerFields.style.display = 'block';
                    if (ownerCardDate) ownerCardDate.style.display = "block";
                }
            });
        });
    }

    getSelectedPaymentMethod(prefix) {
        const inputName = `${prefix}_wc-vindi-pagamentos-credit-payment-token`;
        const selectedInput = document.querySelector(`input[name="${inputName}"]:checked`);
        return selectedInput ? selectedInput.value : null;
    }
}